import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { OwlModule } from 'ngx-owl-carousel';
import { FileUploadModule } from 'primeng/primeng';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgArrayPipesModule } from 'angular-pipes';

import {
	HeaderComponent,
	SidebarComponent,
	StageComponent,
	IntroComponent,
	PortalComponent,
	SliderComponent,
	SyncComponent,
	ContentComponent,
	TabComponent,
	FormComponent,
	SendComponent,
	ImprintComponent,
	PrivacyComponent,
	FooterComponent
} from '@components';

import {
	SidebarService,
	SceneService,
	DexieService,
	SyncService,
	FileService
} from '@services';

import {
	NetworkHelpers
} from '@helpers';

import {
	SidebarGuard,
	SceneGuard
} from '@guards';

import {
	LongPressDirective
} from '@directives';

import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgOverlayPlayModule } from 'videogular2/overlay-play';
import { VgBufferingModule } from 'videogular2/buffering';

import 'hammerjs';
import 'hammer-timejs';

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
	declarations: [
		AppComponent,
		IntroComponent,
		PortalComponent,
		HeaderComponent,
		SidebarComponent,
		StageComponent,
		LongPressDirective,
		SliderComponent,
		SyncComponent,
		ContentComponent,
		TabComponent,
		FormComponent,
		SendComponent,
		ImprintComponent,
		PrivacyComponent,
		FooterComponent
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		FileUploadModule,
		VgCoreModule,
		VgControlsModule,
		VgOverlayPlayModule,
		VgBufferingModule,
		ReactiveFormsModule,
		HttpClientModule,
		OwlModule,
		NgArrayPipesModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (createTranslateLoader),
				deps: [HttpClient]
			}
		})
	],
	providers: [
		SidebarService,
		SceneService,
		DexieService,
		SyncService,
		FileService,
		NetworkHelpers,
		SidebarGuard,
		SceneGuard
	],
	bootstrap: [
		AppComponent
	]
})
export class AppModule
{}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/app.module.ts